import { supabase } from "@/lib/supabase";
import { normalizeTaxonomies } from "@/lib/taxonomies";

// অ্যাডমিনের ক্যাটাগরি CRUD। অনুমতি দেয় RLS (শুধু admin) — key/value বদলানো যায় না (column grant), আর
// ব্যবহৃত মান মোছা যায় না (trigger); এখানে শুধু কল আর error-বার্তা। (supabase/migrations/0005)

const SELECT = "id, key, label_bn, label_en, multi, required, sort, active, terms(id, value, label_bn, label_en, sort, active)";

async function mutate(query) {
  const { error } = await query;
  if (error) throw error;
}

// update/delete RLS-এ আটকে গেলে PostgREST error দেয় না, ০টা row ফেরত দেয় — সেটাকেও ব্যর্থতা ধরি
async function mutateRows(query) {
  const { data, error } = await query.select("id");
  if (error) throw error;
  if (!data?.length) throw new Error("gallery:not_allowed");
}

export async function fetchTaxonomiesAdmin() {
  const { data, error } = await supabase.from("taxonomies").select(SELECT);
  if (error) throw error;
  return normalizeTaxonomies(data ?? []);
}

export const createTaxonomy = (row) => mutate(supabase.from("taxonomies").insert(row));
export const updateTaxonomy = (id, patch) => mutateRows(supabase.from("taxonomies").update(patch).eq("id", id));
export const deleteTaxonomy = (id) => mutateRows(supabase.from("taxonomies").delete().eq("id", id));

export const createTerm = (taxonomyId, row) => mutate(supabase.from("terms").insert({ taxonomy_id: taxonomyId, ...row }));
export const updateTerm = (id, patch) => mutateRows(supabase.from("terms").update(patch).eq("id", id));
export const deleteTerm = (id) => mutateRows(supabase.from("terms").delete().eq("id", id));

// পরের/আগের সারির সাথে জায়গা বদল। সব সারিকে ১০, ২০, ৩০… করে নতুন করে সাজায়, কিন্তু শুধু যেগুলোর sort
// সত্যিই বদলায় সেগুলোই আপডেট হয় (প্রথমবারের পর সাধারণত ২টা)।
export async function moveItems(table, list, index, delta) {
  const target = index + delta;
  if (target < 0 || target >= list.length) return;
  const next = [...list];
  [next[index], next[target]] = [next[target], next[index]];
  const changed = next
    .map((item, i) => ({ id: item.id, sort: (i + 1) * 10, was: item.sort }))
    .filter((u) => u.sort !== u.was);
  await Promise.all(changed.map((u) => mutateRows(supabase.from(table).update({ sort: u.sort }).eq("id", u.id))));
}

export const nextSort = (list) => list.reduce((max, x) => Math.max(max, x.sort ?? 0), 0) + 10;

export const KEY_PATTERN = /^[a-z][a-z0-9_]{1,29}$/;
export const VALUE_PATTERN = /^[a-z0-9][a-z0-9-]{0,39}$/;

export function adminErrorMessage(err) {
  const msg = String(err?.message ?? "");
  if (msg.includes("gallery:term_in_use")) return "এটা কোনো পেপারে ব্যবহার হচ্ছে, তাই মোছা যাবে না। চাইলে নিষ্ক্রিয় করে দাও (পুরনো পেপারে থাকবে, নতুন পেপারে বাছা যাবে না)।";
  if (msg.includes("gallery:protected_taxonomy")) return "এটা মূল ক্যাটাগরি (পুরনো অ্যাপের সাথে জড়িত), মোছা যায় না। নিষ্ক্রিয় করা যায়।";
  if (msg.includes("gallery:not_allowed") || err?.code === "42501") return "অনুমতি নেই — এই কাজ শুধু অ্যাডমিন করতে পারে।";
  if (err?.code === "23505") return "এই key/মান আগেই আছে।";
  if (err?.code === "23514") return "ফরম্যাট ঠিক নেই। key: ছোট ইংরেজি অক্ষর, সংখ্যা বা _ ; মান: ছোট ইংরেজি অক্ষর, সংখ্যা বা -";
  return "কাজটা করা যায়নি, আবার চেষ্টা করো।";
}
